import {ShouldBlockFn, useBlocker} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

interface Props {
  shouldBlock: boolean | ShouldBlockFn
  enableBeforeUnload?: boolean | (() => boolean)
}

export function useBlockerDialog({shouldBlock, enableBeforeUnload = true}: Props) {
  const {t} = useTranslate('common')

  // beforeunload has no navigation args, so a boolean shouldBlock can be read directly
  const blocksBeforeUnload = typeof shouldBlock === 'boolean' ? shouldBlock : true

  function onBlock() {
    const confirmed = window.confirm(t('you_have_unsaved_changes_sure_proceed'))
    return !confirmed
  }

  const block: ShouldBlockFn = args => {
    const block = typeof shouldBlock === 'boolean' ? shouldBlock : shouldBlock(args)
    if (!block || window.__isForceReloading) return false
    return onBlock()
  }

  const beforeUnload = () => {
    const enable = typeof enableBeforeUnload === 'boolean' ? enableBeforeUnload : enableBeforeUnload()
    // an untouched form must not warn on reload/close, exactly like the in-app blocker
    if (!enable || !blocksBeforeUnload || window.__isForceReloading) return false
    return onBlock()
  }

  useBlocker({
    shouldBlockFn: block,
    enableBeforeUnload: beforeUnload,
  })
}
